module.exports = __webpack_public_path__ + "static/media/food-truck-nation.f5a302f2.jpg";